module.exports = __webpack_public_path__ + "static/media/24UHCHR2.362715d8.jpg";